/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface GetQaRtSystemTemplateDto
 */
export interface GetQaRtSystemTemplateDto {
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof GetQaRtSystemTemplateDto
     */
    taskType?: TaskTypeDescription;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetQaRtSystemTemplateDto
     */
    supportSystemEntityIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetQaRtSystemTemplateDto
     */
    $type?: GetQaRtSystemTemplateDtoTypeEnum;
}


/**
 * @export
 */
export const GetQaRtSystemTemplateDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoGetQaRtSystemTemplateDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.GetQaRtSystemTemplateDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type GetQaRtSystemTemplateDtoTypeEnum = typeof GetQaRtSystemTemplateDtoTypeEnum[keyof typeof GetQaRtSystemTemplateDtoTypeEnum];


/**
 * Check if a given object implements the GetQaRtSystemTemplateDto interface.
 */
export function instanceOfGetQaRtSystemTemplateDto(value?: unknown): value is GetQaRtSystemTemplateDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(GetQaRtSystemTemplateDtoTypeEnum)[0];
}

export function GetQaRtSystemTemplateDtoFromJSON(json: any): GetQaRtSystemTemplateDto {
    return GetQaRtSystemTemplateDtoFromJSONTyped(json, false);
}

export function GetQaRtSystemTemplateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetQaRtSystemTemplateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'taskType': !exists(json, 'taskType') ? undefined : TaskTypeDescriptionFromJSON(json['taskType']),
        'supportSystemEntityIds': !exists(json, 'supportSystemEntityIds') ? undefined : json['supportSystemEntityIds'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function GetQaRtSystemTemplateDtoToJSON(value?: GetQaRtSystemTemplateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'taskType': TaskTypeDescriptionToJSON(value.taskType),
        'supportSystemEntityIds': value.supportSystemEntityIds,
        '$type': value.$type,
    });
}

